import React, { useState } from "react";
import { RADAR_LABEL_COLOR_ORDER, RADAR_LABEL_COLORS, radarLabelHex } from "../../constants/agentRadarChoices";

// Label assign/create menu content for the entry detail. TEMPLATE ORIGIN:
// components/scout-request/PriorityLabelMenu.jsx — copied and stripped of ALL
// agency attribution (no priority section, no "only your agency"/"Shared with your
// agency" wording): this is a personal tool. Lists the owner's unassigned labels
// to assign, plus a name + 6-swatch composer to create one. The parent owns the
// "+ Label" trigger and popover/sheet framing; this renders the contents only.
const RadarLabelEditor = ({ availableLabels = [], onAssign, onCreate }) => {
  const [creating, setCreating] = useState(false);
  const [name, setName] = useState("");
  const [color, setColor] = useState("blue");
  const [busy, setBusy] = useState(false);

  const create = async () => {
    const v = name.trim();
    if (!v || busy) return;
    setBusy(true);
    const res = await onCreate({ name: v, color });
    setBusy(false);
    if (res?.success) {
      setName("");
      setColor("blue");
      setCreating(false);
    }
  };

  return (
    <div>
      {availableLabels.map((al) => (
        <button
          key={al.id}
          type="button"
          onClick={() => onAssign(al)}
          className="flex items-center w-full text-left bg-transparent border-none rounded-md text-[12.5px] text-[#374151] font-medium cursor-pointer hover:bg-[#F3F6FA]"
          style={{ gap: 8, padding: "7px 9px" }}
        >
          <span style={{ width: 7, height: 7, borderRadius: "50%", background: radarLabelHex(al.color), flexShrink: 0, display: "inline-block" }} />
          {al.name}
        </button>
      ))}

      {!creating ? (
        <button
          type="button"
          onClick={() => setCreating(true)}
          className="block w-full text-left bg-transparent border-none rounded-md text-[12.5px] text-[#2283FF] font-semibold cursor-pointer hover:bg-[#F3F6FA]"
          style={{ padding: "7px 9px" }}
        >
          + Create new label
        </button>
      ) : (
        <div style={{ padding: "6px 4px 4px", borderTop: "1px solid #EEF1F5", marginTop: 4 }}>
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && create()}
            autoFocus
            placeholder="Label name"
            maxLength={40}
            className="w-full outline-none"
            style={{ height: 29, border: "1px solid #DDE3EB", borderRadius: 8, padding: "0 8px", fontSize: 12.5, marginBottom: 7 }}
          />
          <div className="flex" style={{ gap: 5, marginBottom: 8 }}>
            {RADAR_LABEL_COLOR_ORDER.map((key) => (
              <button
                key={key}
                type="button"
                aria-label={`${key} label colour`}
                onClick={() => setColor(key)}
                style={{
                  width: 22,
                  height: 22,
                  borderRadius: "50%",
                  background: RADAR_LABEL_COLORS[key],
                  cursor: "pointer",
                  border: color === key ? "2px solid #111827" : "2px solid #FFFFFF",
                  boxShadow: "0 0 0 1px #E4E9F0",
                  padding: 0,
                }}
              />
            ))}
          </div>
          <button
            type="button"
            onClick={create}
            disabled={busy || !name.trim()}
            className="w-full bg-[#2283FF] hover:bg-[#1B6FE0] text-white border-none font-semibold cursor-pointer disabled:opacity-50"
            style={{ borderRadius: 8, padding: "7px 0", fontSize: 12 }}
          >
            Add label
          </button>
        </div>
      )}
    </div>
  );
};

export default RadarLabelEditor;
